"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dummyUser2 = exports.dummyUser1 = exports.userDeserializeWithoutId = exports.userDescription = exports.userDeserialize = void 0;
const Array_1 = require("../type-descriptions/Array");
const Boolean_1 = require("../type-descriptions/Boolean");
const ModelDescription_1 = require("../type-descriptions/ModelDescription");
const String_1 = require("../type-descriptions/String");
const unwrap_1 = __importDefault(require("../util/unwrap"));
const BaseUser_1 = require("./BaseUser");
const deserializeArray_1 = __importDefault(require("./deserializeArray"));
const deserializeBoolean_1 = __importDefault(require("./deserializeBoolean"));
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const EmergencyContact_1 = require("./EmergencyContact");
function userDeserialize(value, id) {
    return Object.assign({ id: (0, deserializeString_1.deserializeString)(id) }, userDeserializeWithoutId(value));
}
exports.userDeserialize = userDeserialize;
exports.userDescription = (0, ModelDescription_1.modelDescription)({
    properties: Object.assign({ id: (0, String_1.stringDescription)(), email: Object.assign(Object.assign({}, (0, String_1.stringDescription)()), { isOptional: true }), emergencyContacts: Object.assign(Object.assign({}, (0, Array_1.arrayDescription)({ elementDescription: EmergencyContact_1.emergencyContactOldDescription, userFacingTitle: 'emergency contacts' })), { isOptional: true }), fcmRegistrationTokens: Object.assign(Object.assign({}, (0, Array_1.arrayDescription)({ elementDescription: (0, String_1.stringDescription)(), userFacingTitle: 'emergency contacts' })), { isOptional: true }), invoiceFormulaId: Object.assign(Object.assign({}, (0, String_1.stringDescription)()), { isOptional: true }), isPhoneVerified: Object.assign(Object.assign({}, Boolean_1.booleanDescription), { isOptional: true }), nickName: Object.assign(Object.assign({}, (0, String_1.stringDescription)()), { isOptional: true }), payoutFormulaId: Object.assign(Object.assign({}, (0, String_1.stringDescription)()), { isOptional: true }) }, BaseUser_1.baseUserDescription.properties),
});
function userDeserializeWithoutId(value) {
    const object = (0, deserializeObject_1.default)(value);
    return Object.assign({ email: (0, unwrap_1.default)(object.email, deserializeString_1.deserializeString), emergencyContacts: (0, unwrap_1.default)(object.emergencyContacts, deserializeOldEmergencyContacts), fcmRegistrationTokens: (0, unwrap_1.default)(object.fcmRegistrationTokens, tokens => {
            try {
                return deserializeStrings(tokens);
            }
            catch (error) {
                return deserializeStrings(Object.values(tokens));
            }
        }), invoiceFormulaId: (0, unwrap_1.default)(object.invoiceFormulaId, deserializeString_1.deserializeString), isPhoneVerified: (0, unwrap_1.default)(object.isPhoneVerified, deserializeBoolean_1.default), nickName: (0, unwrap_1.default)(object.nickName, deserializeString_1.deserializeString), payoutFormulaId: (0, unwrap_1.default)(object.payoutFormulaId, deserializeString_1.deserializeString) }, (0, BaseUser_1.baseUserDeserialize)(value));
}
exports.userDeserializeWithoutId = userDeserializeWithoutId;
const deserializeOldEmergencyContacts = (0, deserializeArray_1.default)(EmergencyContact_1.emergencyContactDeserializeOldType, true);
const deserializeStrings = (0, deserializeArray_1.default)(deserializeString_1.deserializeString);
exports.dummyUser1 = {
    id: '123',
    firstName: 'Diondre',
    lastName: 'Lewis',
    phone: '+17047047704',
    nickName: 'D',
};
exports.dummyUser2 = {
    id: '456',
    firstName: 'Timothy',
    lastName: 'Hawkins',
    phone: '+17047047704',
    nickName: 'Tim',
};
